import React from 'react';

import CountryInfo from '../CountryInfo';

const FEDERAL_SECTION = {
    title: 'Federaal Plan voor Sociale en Economische Bescherming',
    content: (
        <div>
            <p>
                Tijdens de vergadering van de ministerraad op vrijdag 20 maart
                zijn een aantal maatregelen goedgekeurd om de
                sociaal-economische gevolgen van COVID-19 te verlichten. Ze zijn
                gebaseerd op de aanbevelingen van de Economic Risk Management
                Group (ERMG), die gisteren is bijeengekomen, en op de
                vergadering met de G-10.
                <br />
                <br />
                Deze maatregelen maken deel uit van het tweede luik van het
                zogenaamde Federaal Plan voor Sociale en Economische
                bescherming. Ze komen bovenop de 10 maatregelen die op 6 maart
                2020 werden aangenomen in het kader van het eerste luik van dit
                federale plan.
                <br />
                <br />
                De laatste weken heeft de gezondheidssituatie ons ertoe
                gedwongen moeilijke maatregelen te nemen om de mensen te
                beschermen. Ze hebben een grote impact op de economische spelers
                in België, of het nu gaat om bedrijven, zelfstandigen of
                werknemers.
                <br />
                <br />
                Het was daarom essentieel om beschermende maatregelen te nemen
                voor al deze spelers.
            </p>

            <p className="eds-text-bl eds-l-mar-bot-4 eds-l-mar-top-8">
                Wat betreft de koopkracht van de werknemers
            </p>
            <p>
                De tijdelijke werkloosheid zal automatisch toegekend worden, en
                zal worden uitgebreid en versterkt. Dit betekent dat het bedrijf
                geen verantwoording moet afleggen om er aanspraak op te maken,
                dat tijdelijke werkloosheid ook mogelijk is voor mensen die
                bijvoorbeeld thuis moeten blijven omdat hun partner besmet is.
                En dat de impact op de koopkracht van de werknemers beperkt moet
                worden. Het referentiepercentage wordt namelijk verhoogd van 65
                naar 70% en de werkloosheidsdagen worden gelijkgesteld voor en
                meegerekend in het vakantiegeld en de RVA kent een bedrag van
                ongeveer 5,63 euro per werkloosheidsdag toe.
            </p>
            <br />
            <p>
                Er is geen onderscheid meer tussen werkloosheid om economische
                redenen of wegens overmacht.
            </p>
            <br />
            <p>
                Er zal ook een automatische verlenging van de betalingstermijnen
                van de personenbelasting (twee maanden) worden ingevoerd.
            </p>

            <p className="eds-text-bl eds-l-mar-bot-4 eds-l-mar-top-8">
                Wat betreft de steun voor zelfstandigen die moesten sluiten of
                in moeilijkheden verkeren
            </p>
            <p>
                Het overbruggingsrecht zal het mogelijk maken om een
                maandelijkse toelage van 1.291,69 tot 1.614,10 euro toe te
                kennen aan zelfstandigen in hoofdberoep die hun activiteit niet
                of maar deels kunnen voortzetten door het coronavirus. Dit recht
                zal automatisch gelden voor de sectoren die onder het KB van 16
                maart vallen en wordt onmiddellijk toegepast (maart/april). Voor
                de anderen moet de activiteit zijn stopgezet gedurende 7
                opeenvolgende dagen.
            </p>
            <br />
            <p>
                Er wordt voorzien in uitstel van betaling inzake fiscaliteit
                (twee maanden) en inzake sociale bijdragen (uitstel van voor de
                eerste twee kwartalen). Er is ook voorzien in bepaalde
                vrijstellingen.
            </p>
            <br />
            <p>
                De lokale overheden werd gevraagd om bij te dragen aan de
                inspanning en op gemeenschapsniveau bepaalde belastingen te
                bevriezen.
            </p>

            <p className="eds-text-bl eds-l-mar-bot-4 eds-l-mar-top-8">
                Wat betreft de ondersteuning van kmo’s en bedrijven die moesten
                sluiten of in moeilijkheden verkeren
            </p>
            <p>Bovengenoemd uitstel van betaling is van toepassing.</p>
            <br />
            <p>
                Dienstverleners aan wie federale overheidsopdrachten zijn
                gegund, krijgen geen boetes voor vertragingen in de uitvoering
                van deze opdrachten als zij de gevolgen van COVID-19
                ondervinden. Daarnaast verbinden de autoriteiten zich ertoe de
                betalingstermijn voor deze opdrachten te versnellen.
            </p>
        </div>
    ),
    links: [
        {
            title: 'Coronavirus: lancering van het tweede luik van het Federaal Plan voor Sociale en Economische Bescherming',
            url: 'https://www.belgium.be/nl/nieuws/2020/coronavirus_lancering_van_het_tweede_luik_van_het_federaal_plan_voor_sociale_en',
        },
    ],
};

const SUBSIDY_SECTION = {
    title: 'Corona-hinderpremie',
    content: (
        <p>
            Een onderneming die verplicht haar activiteiten moet stopzetten door
            de coronamaatregelen van de federale regering, kan in aanmerking
            komen voor de corona-hinderpremie van de Vlaamse overheid.
        </p>
    ),
    links: [
        {
            title: 'Procedure',
            url: 'https://www.vlaanderen.be/corona-hinderpremie',
        },
    ],
};

const EVENT_SECTION = {
    title: 'Geannuleerde Evenementen',
    content: (
        <div>
            <p>
                In normale omstandigheden zijn de regels als volgt: bij
                overmacht moet de organisator zijn contractuele verplichtingen
                niet nakomen, dat geldt ook in omgekeerde richting voor de
                klant. Concreet houdt dit in dat de klant de terugbetaling kan
                vragen van reeds betaalde sommen. De organisator kan een
                evenement verplaatsen naar een latere datum, maar de consument
                kan echter niet verplicht worden het evenement op een
                alternatieve datum te aanvaarden en heeft in dit geval het recht
                op de terugbetaling van zijn ticket.
            </p>
            <br />
            <p>
                Deze situatie zou op dit moment leiden tot zwaar inkomensverlies
                en zou heel wat organisaties in ernstige financiële
                moeilijkheden kunnen brengen. Daarom werd deze regeling
                uitgewerkt voor evenementen door getroffen worden door de
                coronacrisis:
            </p>
            <ul>
                <li>
                    De organisator hoeft tijdelijk geen terugbetaling te doen
                    van de tickets wanneer hetzelfde evenement op een latere
                    datum binnen een redelijke termijn wordt georganiseerd
                </li>
                <li>
                    Kan de consument aantonen dat het niet mogelijk is om op die
                    nieuwe datum het evenement bij te wonen kan een
                    terugbetaling van de tickets wel (bv. ziekte,
                    beroepsredenen)
                </li>
                <li>
                    Kan het evenement niet op een later moment worden
                    georganiseerd, moet de organisator voldoende tijd krijgen om
                    de terugbetalingen te doen zodat terugbetalingen in de tijd
                    kunnen worden gespreid.
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Reis of concert geannuleerd? Met deze maatregelen komt regering tegemoet aan sector en klanten',
            url: 'https://www.vrt.be/vrtnws/nl/2020/03/18/minister-muylle-maatregelen-reizen-en-evenementen/',
        },
    ],
};

const FLANDERS_SECTION = {
    title: 'Vlaanderen - Agentschap Innoveren & Ondernemen',
    content: (
        <div>
            <p>
                Om de elektronische steunmaatregelen van Agentschap voor
                Innoveren & Ondernemen te kunnen gebruiken moet je jouw
                onderneming registreren op het online platform (INKOM). Je
                krijgt toegang tot het online platform d.m.v. een
                identiteitscontrole via het Toegangsbeheer van de Vlaamse
                overheid (ACM – Access Control Management) én als je over de
                juiste gebruikersrechten beschikt. Het beheer van die rechten
                gebeurt via het Gebruikersbeheer van de Vlaamse overheid (IDM –
                Identity Management).
            </p>
        </div>
    ),
    links: [
        {
            title: 'Registratie van een onderneming - Corona hinderpremie aanvragen',
            url: 'https://www.vlaio.be/nl/subsidies-financiering/corona-hinderpremie/hoe-vraag-je-de-corona-hinderpremie-aan/registratie-van',
        },
    ],
};

const WALLONIE_SECTION = {
    title: 'Wallonie - Indemnisation Entreprises et Indépendants ',
    content: (
        <div>
            <p>
                Afin de soutenir les entreprises et indépendants directement
                impactés par ces mesures, le Gouvernement wallon a constitué un
                fonds extraordinaire de 233 millions EUR. Les entreprises et
                indépendants fortement touchés par les fermetures liées à la
                lutte contre le coronavirus seront indemnisés à hauteur de 5.000
                EUR sous réserve d&apos;acceptation après vérification de votre
                dossier par le Service de l&apos;Inspection Wallonne.
            </p>
            <br />
            <p>
                Le Gouvernement wallon octroie une indemnité forfaitaire unique
                de 5.000 EUR à chaque entreprise et indépendant contraint de
                fermer ou d’arrêter ses activités suite aux mesures du Conseil
                National de Sécurité. Pour pouvoir bénéficier de cette
                indemnité, vous devez être une petite ou micro-entreprise en
                activité, avoir un siège en Wallonie et être actif dans un des
                secteurs visés.
            </p>
        </div>
    ),
    links: [
        {
            title: 'COVID19 : Procédure pour introduire une demande d’indemnisation',
            url: 'https://indemnitecovid.wallonie.be/#/',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'Belgium',
    lastUpdated: 'March 27, 2020',
    introSection: <p></p>,
    sections: [
        FEDERAL_SECTION,
        EVENT_SECTION,
        SUBSIDY_SECTION,
        FLANDERS_SECTION,
        WALLONIE_SECTION,
    ],
};

const BelgiumInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default BelgiumInfo;
